import { WorkplaceInCoworkingType } from 'shared/enums/WorkplaceInCoworkingType';
import { ECoworkingOfferType } from 'shared/repositories/coworking/entities/api/V1BookCoworkingRequestSchema';

export function getPlaceModalType(type: WorkplaceInCoworkingType): ECoworkingOfferType {
  switch (type) {
    case WorkplaceInCoworkingType.FlexibleWorkplace:
      return ECoworkingOfferType.FlexibleWorkplace;

    case WorkplaceInCoworkingType.FixedWorkplace:
      return ECoworkingOfferType.FixedWorkplace;

    default:
      throw new Error(`getPlaceModalType поле ${type} в енаме WorkplaceInCoworkingType не объявлено`);
  }
}
